// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"56121b72","952":"2a560456"}[chunkId] + ".chunk.js";
};